import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CouponModel, IConfigObj } from '../models/data.model';
import { Observable, defer, of } from 'rxjs';
import { Subject } from 'rxjs';

import { map, catchError } from 'rxjs/operators';
import { CommonService } from './common.service';
import { EnviormentConfig } from '../wcax-env-config';
import { UserInfoService } from './user-info.service'
import { UtilService } from './util.service';

declare let $: any;
@Injectable({
  providedIn: 'root'
})
export class ProductCouponService {

  public disableNDC: boolean;
  public currentEnv = '';
  public clipDigitalCouponSubject = new Subject<any>();
  public clipDigitalCouponEvent$ = this.clipDigitalCouponSubject.asObservable();

   // DFTA - wcax env config
   private config = EnviormentConfig;

    public constructor(
        private http: HttpClient,
        private _commonService: CommonService,
        private _userInfoService: UserInfoService,
        private _http: HttpClient,
        private _utilService : UtilService
    ) {
        //this.disableNDC = window['SWY']['CONFIGSERVICE'] && window['SWY']['CONFIGSERVICE'].featureToggleConfig && window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableNDC ? true : false;
        this.disableNDC = false;
        this.currentEnv = this._commonService.getCurrentEnviorment();

    }

    /**
     * Get numbers of clipped offers.
     *
     * @param {CouponModel[]} coupons Product coupons object.
     */
    public getOffersClipped(coupons: CouponModel[]): number {
        let count = 0;

        coupons.forEach(c => {
            if ((c.status === 'C' && c.deleted === false) || c.isClippable === false) {
                count++;
            }
        });

        return count;
    }

    /**
     * Get numbers of clipped offers.
     *
     * @param {CouponModel[]} coupons Product coupons object.
     */
    public getCouponsCompletedCounter(coupons: CouponModel[]): number {
        let count = 0;

        coupons.forEach(coupon => {
            if ((coupon.isClippable === false && coupon.offerComplete === true) || (coupon.status === 'C' && coupon.deleted === false && coupon.offerComplete === true)) {
                count++;
            }
        });

        return count;
    }

    /**
     * Check if localstorage is available on user's device.
     */
    private _checkLocalStorage(): boolean {
        try {
            localStorage.setItem('test', 'test');
            localStorage.removeItem('test');
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
    * Check if coupon is expired or not
    */
    public isCouponExpired(coupon) {
        const today = new Date();
        const day = today.getDate();
        const month = today.getMonth() + 1;
        const year = today.getFullYear();
        const dateString = `${month}/${day}/${year}`;
        const finalDate = new Date(dateString);


        const endDateMilliSeconds = parseInt(coupon.endDate);
        const endDate = new Date(endDateMilliSeconds);
        const endDay = endDate.getDate();
        const endMonth = endDate.getMonth() + 1;
        const endYear = endDate.getFullYear();
        const couponendDateString = `${endMonth}/${endDay}/${endYear}`;
        const couponEndDate = new Date(couponendDateString);

        return couponEndDate < finalDate
    }
    /**
     * Emit Observable to clip digital and single coupon 
     */
    public clipDigitalCoupon(productUpc : string)  {
        this.clipDigitalCouponSubject.next(productUpc);
    }

    public clipCoupon(coupon: CouponModel, storeId: string, configObj?: IConfigObj, analyticsData?: any): Observable<any> {
      
      // DFTA integration @@TODO - need to un hardcode bannner , 
      const httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'SWY_SSO_TOKEN': this._userInfoService.getSWY_SHOP_TOKEN(),
            "X-IBM-Client-Id": this.config[this.currentEnv].j4uAPIDetails['X-IBM-Client-Id'],
            "X-IBM-Client-Secret": this.config[this.currentEnv].j4uAPIDetails['X-IBM-Client-Secret'],
            "X-SWY_API_KEY" : "emjou",
            "X-SWY_BANNER" : "safeway",
            "X-SWY_VERSION" : "1.0",
            "X-swyConsumerDirectoryPro" : this._userInfoService.getSWY_SHOP_TOKEN(),
            "x-swy-correlation-id" : this._commonService.generateUUID()
        })
      };

      // DFTA integration @@TODO - need to remove host , how to handle local env ?
      let clipUrl = this.config[this.currentEnv].j4uAPIDetails['clipPath'] + '?storeId=' + this._userInfoService.getShopStoreId();
      if (configObj && configObj.bannerDomain) {
        clipUrl = configObj.bannerDomain + clipUrl;
      }
      let result: Observable<any> = defer(() => of({}));
      
      let reqBody = {};

      if(coupon.deleted) {
          reqBody = {
              items: [
                  {
                      clipType: 'L',
                      itemId: coupon.offerId,
                      itemType: coupon.offerPgm
                  }
              ]
          };
      } else {
          reqBody = {
              items: [
                  {
                      clipType: 'C',
                      itemId: coupon.offerId,
                      itemType: coupon.offerPgm
                  },
                  {
                      clipType: 'L',
                      itemId: coupon.offerId,
                      itemType: coupon.offerPgm
                  }
              ]
          };
      }

      result = this.http.post(clipUrl, reqBody, httpOptions).pipe(
        map((response) => {
            console.warn('clip response', response);
            if(response && response['items']) {
                if (response['items'][0]['status'] == 1) {
                    coupon.status = 'C';
                    coupon.deleted = false;
                    // Local Storage implementation
                    // if(this._commonService.isLSCompatible() && localStorage.abJ4uCoupons != undefined ) {
                    //     let abJ4uCoupons = JSON.parse(localStorage.abJ4uCoupons);
                    //     if (abJ4uCoupons) {
                    //         let objCoupons = abJ4uCoupons['objCoupons'];
                    //         if(objCoupons && objCoupons[coupon.offerId] != undefined){
                    //             let tempCoupon = objCoupons[coupon.offerId];
                    //             tempCoupon.status = 'C';
                    //             tempCoupon.deleted = false;
                    //             /* custom code for instant allocation
                    //              * can be deleted once campaign is completed */
                    //             if (tempCoupon.instantAllocation == true) {
                    //                  abJ4uCoupons['instantAllocOffer'] = [];
                    //                  tempCoupon.instantAllocation = undefined;
                    //             }

                    //         }
                    //         abJ4uCoupons['arrClippedCoupons'] = [...abJ4uCoupons['arrClippedCoupons'], coupon.offerId];
                    //         localStorage.abJ4uCoupons = JSON.stringify(abJ4uCoupons);
                    //     }
                    // }
                    this._commonService.clipEcomGalleryCoupon(coupon.offerId);

                    // update analytics data layer
                    const _coupon = {
                        "brand": coupon['instantAllocation'] ? 'welcome-offer-clip' : coupon.brand,
                        "offerType": coupon.offerPgm,
                        "offerId": coupon.offerId,
                        "offerPrice": coupon.offerPrice,
                        "carouselSection": window && window['digitalData'] && window['digitalData']['productInfo'] && window['digitalData']['productInfo'].carouselSection || ''
                    };
                    if (window && window['AB'] && window['AB']['DATALAYER']) {
                        window['AB']['DATALAYER'].clipCoupon(_coupon, analyticsData);
                    }

                } else if (response['items'][0]['status'] == 0) {
                    // DFTA - do we need this modal ?? currently lives in AEM footers

                    $('#errorModal').modal({'show': true});

                    let strError = "200: Coupon Expired";
                    if(response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }

                    //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);

                } else {

                    $('#errorModal').modal({'show': true});
                    let strError = "200: Coupon Clip failed - status is not either 0 or 1";
                    if(response['items'][0].errorCd && response['items'][0].errorMsg) {
                        strError += " " + response['items'][0].errorCd + " " + response['items'][0].errorMsg;
                    }

                    //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
                }

            } else {

                $('#errorModal').modal({'show': true});
                let strError = "200: Coupon Clip failed - items is not defined ";
                if(response['errorCd'] && response['errorMsg']) {
                    strError += " " + response['errorCd'] + " " + response['errorMsg'];
                }

                //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);
            }

          return response;
        }),
        catchError((err) => {
            console.error('clip error', err);
            let strError = err.status + ": Coupon Clip failed";
            if(typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }

            //window['AB']['DATALAYER'].setError(coupon.offerId.toString(), 'coupon clipping', strError);

            return null;
        })
      );

      return result;
  }

  public unclipCoupon(offer: any): Observable<any> {

      const httpOptions = { headers: new HttpHeaders(window['AB'].j4uHttpOptions) };
      const unClipUrl = window['AB']['couponUnclipPath'];
      let result: Observable<any> = defer(() => of({}));

      const body = { items: [{ id: offer.id }] };

      result = this.http.post(unClipUrl, body, httpOptions).pipe(
        map((response) => {
            // if(this.appConfigService.isLSCompatible() && localStorage.abJ4uCoupons != undefined ) {
            //     let abJ4uCoupons = JSON.parse(localStorage.abJ4uCoupons);
            //     if (abJ4uCoupons) {
            //         let objCoupons = abJ4uCoupons['objCoupons']
            //         if(objCoupons && objCoupons[offer.referenceId] != undefined ){
            //             let tempCoupon = objCoupons[offer.referenceId];
            //             tempCoupon.deleted = true;
            //             tempCoupon.status = 'U';
            //             if(tempCoupon.events.includes("Welcome Offers")) {
            //                 tempCoupon.instantAllocation = true;
            //                 abJ4uCoupons['instantAllocOffer'] = [tempCoupon];
            //             }
            //         }

            //         abJ4uCoupons['arrClippedCoupons'] = abJ4uCoupons['arrClippedCoupons'].filter(id => id != offer.referenceId);
            //         localStorage.abJ4uCoupons = JSON.stringify(abJ4uCoupons);
            //     }
            // }

            this._commonService.unclipEcomGalleryCoupon(offer.referenceId);

            const _coupon = {
                "brand": offer.title,
                "offerType": offer.itemType,
                "offerId": offer.referenceId,
                "offerPrice": offer.savingsValue
            };

            window['AB']['DATALAYER'].unClipCoupon(_coupon);
            //add 'ecoupon' flag in cookie to show shop coupon has been unclipped
            window['SWY'].ENFORCEMENTUTILS.updateReInitSite('ecoupon');

            return response;
        }),
        catchError((err) => {
            console.error('Unclip error', err);
            let strError = err.status + ": Coupon UnClip failed";
            if(typeof err.error == "object" && Array.isArray(err.error.errors) && err.error.errors.length > 0) {
                strError += " " + err.error.errors[0].code + " " + err.error.errors[0].msg;
            }

            //window['AB']['DATALAYER'].setError(offer.id.toString(), 'coupon clipping', strError);

            return null;
        })
      );
      
      return result;
  }
}
